class newPincodeChecker extends HTMLElement {
    constructor() {
        super();
        this.initVariables();
    }

    initVariables() {
        this.input = this.querySelector('.npc__input');
        this.button = this.querySelector('.npc__button');
        this.result = this.querySelector('.npc__result');
        this.form = this.querySelector('.npc__form');
        this.header = this.querySelector('.npc__header');
        this.subtitle = this.querySelector('.npc__subtitle');
        this.changeBtn = this.querySelector('.npc__change-btn');
        this.resultPincode = this.querySelector('.npc__result-pincode');
        this.resultMessage = this.querySelector('.npc__result-message');
        this.resultDelivery = this.querySelector('.npc__result-delivery');
        this.resultLocation = this.querySelector('.npc__result-location');
    }

    connectedCallback() {
        this.input.addEventListener('input', this.handlePincodeInput.bind(this));
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.changeBtn.addEventListener('click', this.handleChange.bind(this));
        this.loadSavedPincode();
    }

    handlePincodeInput() {
        // strip non-numeric characters
        this.input.value = this.input.value.replace(/\D/g, '');
        this.button.disabled = this.input.value.length !== 6;
    }

    async handleFormSubmit(e) {
        e.preventDefault();
        const pincode = this.input.value;
        if (pincode.length !== 6) return;

        this.button.disabled = true;
        this.button.textContent = 'Checking...';

        const deliveryData = await this.fetchDeliveryData(pincode);
        this.savePincode(pincode);
        this.showResult(deliveryData);

        this.button.textContent = 'Check';
        this.button.disabled = false;
    }

    async fetchDeliveryData(pincode) {
        try {
            const response = await fetch(
                `https://marmeto.wholsumfoods.com/api/expectedDelivery?destination_pin=${pincode}`
            );
            const result = await response.json();

            if (result.success && result.data) {
                return {
                    pincode,
                    available: true,
                    message: 'Yay! Your pincode is eligible for delivery.',
                    deliveryDate: this.getDeliveryDate(result.data.tat),
                    city: result.data.city,
                    state: result.data.state,
                };
            }

            return {
                pincode,
                available: false,
                message: 'Sorry, delivery is not available for this pincode.',
                deliveryDate: null,
            };
        } catch (error) {
            console.error('Pincode check failed:', error);
            return {
                pincode,
                available: false,
                message: 'Something went wrong. Please try again.',
                deliveryDate: null,
            };
        }
    }

    getDeliveryDate(tat) {
        const date = new Date();
        date.setDate(date.getDate() + tat);
        const options = { weekday: 'long', day: 'numeric', month: 'long' };
        return date.toLocaleDateString('en-IN', options);
    }

    showResult(data) {
        this.resultPincode.textContent = data.pincode;
        this.resultMessage.textContent = data.message;

        if (data.available && data.deliveryDate) {
            this.resultDelivery.textContent = 'Delivery by ' + data.deliveryDate;
            this.resultDelivery.style.display = 'block';
        } else {
            this.resultDelivery.style.display = 'none';
        }

        if (data.city && data.state) {
            this.resultLocation.textContent = data.city + ', ' + data.state;
            this.resultLocation.style.display = 'block';
        } else {
            this.resultLocation.style.display = 'none';
        }

        // hide input view, show result view
        this.header.style.display = 'none';
        this.form.style.display = 'none';
        this.subtitle.style.display = 'none';
        this.result.style.display = 'block';
    }

    handleChange() {
        // reset back to input view
        this.clearSavedPincode();
        this.result.style.display = 'none';
        this.header.style.display = 'flex';
        this.form.style.display = 'flex';
        this.subtitle.style.display = 'flex';
        this.input.value = '';
        this.button.disabled = true;
        this.input.focus();
    }

    savePincode(pincode) {
        localStorage.setItem('npc_pincode', pincode);
    }

    async loadSavedPincode() {
        const savedPincode = localStorage.getItem('npc_pincode');
        if (savedPincode && savedPincode.length === 6) {
            const deliveryData = await this.fetchDeliveryData(savedPincode);
            this.showResult(deliveryData);
        }
    }

    clearSavedPincode() {
        localStorage.removeItem('npc_pincode');
    }
}

customElements.define('new-pincode-checker', newPincodeChecker);
